const host = process.env.REACT_APP_API_BASE_URL;
const target = process.env.REACT_APP_BUILD_TARGET;

const routes = {
  auth: `${host}/${target || 'user'}/account`,
  languages: `${host}/api/language/search`,
  currencies: `${host}/api/currency/search`,
  configs: `${host}/api/config/search`,

  login: `${host}/${target || 'user'}/login`,

  attachment: `${host}/manage/attachment`,
  attachmentEdit: `${host}/manage/attachment/edit`,
  attachments: `${host}/manage/attachment/search`,

  post: `${host}/manage/post`,
  postCreate: `${host}/manage/post/create`,
  postEdit: `${host}/manage/post/edit`,
  postSequence: `${host}/manage/post/sequence`,
  posts: `${host}/manage/post/search`,

  postCategory: `${host}/manage/post/category`,
  postCategoryCreate: `${host}/manage/post/category/create`,
  postCategoryEdit: `${host}/manage/post/category/edit`,
  postCategories: `${host}/manage/post/category/search`,

  postTag: `${host}/manage/post/tag`,
  postTagCreate: `${host}/manage/post/tag/create`,
  postTagEdit: `${host}/manage/post/tag/edit`,
  postTags: `${host}/manage/post/tag/search`,

  offer: `${host}/manage/offer`,
  offerCreate: `${host}/manage/offer/create`,
  offerEdit: `${host}/manage/offer/edit`,
  offerSequence: `${host}/manage/offer/sequence`,
  offers: `${host}/manage/offer/search`,

  offerAmenity: `${host}/manage/offer/amenity`,
  offerAmenityCreate: `${host}/manage/offer/amenity/create`,
  offerAmenityEdit: `${host}/manage/offer/amenity/edit`,
  offerAmenities: `${host}/manage/offer/amenity/search`,

  offerModule: `${host}/manage/offer/module`,
  offerModuleCreate: `${host}/manage/offer/module/create`,
  offerModuleEdit: `${host}/manage/offer/module/edit`,
  offerModules: `${host}/manage/offer/module/search`,

  offerModuleType: `${host}/manage/offer/module/type`,
  offerModuleTypeCreate: `${host}/manage/offer/module/type/create`,
  offerModuleTypeEdit: `${host}/manage/offer/module/type/edit`,
  offerModuleTypes: `${host}/manage/offer/module/type/search`,

  offerPlanning: `${host}/manage/offer/planning`,
  offerPlanningCreate: `${host}/manage/offer/planning/create`,
  offerPlanningEdit: `${host}/manage/offer/planning/edit`,
  offerPlannings: `${host}/manage/offer/planning/search`,

  offerType: `${host}/manage/offer/type`,
  offerTypeCreate: `${host}/manage/offer/type/create`,
  offerTypeEdit: `${host}/manage/offer/type/edit`,
  offerTypes: `${host}/manage/offer/type/search`,

  translation: `${host}/api/translation`,
  translationEdit: `${host}/manage/translation/edit`,
  translations: `${host}/manage/translation/search`,

  seo: `${host}/manage/seo/search`,
  seoCreate: `${host}/manage/seo/create`,
  seoEdit: `${host}/manage/seo/edit`,
  seoOne: `${host}/manage/seo`,

  pages: `${host}/manage/page/search`,
  pageCreate: `${host}/manage/page/create`,
  pageEdit: `${host}/manage/page/edit`,
  page: `${host}/manage/page`,
};

export default routes;
